module.exports = __webpack_public_path__ + "static/media/send.e5196977.svg";